const state = () => ({
  dialogButtons: []
});

const getters = {
  dialogButtons(state) {
    return state.dialogButtons;
  }
};

const mutations = {
  setDialogButtons(state, payload) {
    state.dialogButtons = payload;
  }
};

const actions = {
  setDialogButtons({ commit }, payload) {
    commit('setDialogButtons', payload);
  }
};

export const medicalProcedure = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
